
import React from 'react';
import { NavbarContainer } from './NavbarContainer';
import DesktopNavigation from './DesktopNavigation';
import MobileMenu from './MobileMenu';
import { MobileMenuButton } from './MobileMenuButton';
import { Logo } from './Logo';
import { useNavbarState } from './useNavbarState';
import { useIsMobile } from '@/hooks/use-mobile';

const Navbar = () => {
  const {
    isScrolled,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    isAuthenticated,
    isAuthLoading,
    handleSignOut
  } = useNavbarState();
  
  const isMobile = useIsMobile();

  return (
    <NavbarContainer isScrolled={isScrolled}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Logo />

          {/* Desktop Navigation */}
          <DesktopNavigation 
            isAuthenticated={isAuthenticated} 
            onSignOut={handleSignOut}
          />

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <MobileMenuButton 
              isOpen={isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            />
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu 
        isOpen={isMobileMenuOpen}
        isAuthenticated={isAuthenticated} 
        onSignOut={handleSignOut}
        onClose={() => setIsMobileMenuOpen(false)}
      />
    </NavbarContainer>
  );
};

export default Navbar;
